<div class="refresh">
  <div class="text-center">
    <h1>{{refreshingDataText}}</h1>
  </div>
  <div style="display: flex; justify-content: center">
    <img src="/assets/images/loading/refresh_loading.gif" style="height:15rem;width:15rem" />
  </div>
</div>
